import React from "react";
import { CheckCircle2 } from "lucide-react";

const BENEFITS = [
  "Centralised verification tracking across all clients",
  "Real-time status updates that remove follow-up admin",
  "Secure client verification via mobile or browser",
  "Record storage aligned to audit and inspection needs",
  "Connected workflows through the CoSec Global suite",
  "Scalable management for high-volume verification workloads",
];

export default function Benefits() {
  return (
    <section className="py-20 md:py-28 bg-secondary/40 border-y border-border">
      <div className="container-cv grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <span className="section-eyebrow">How CoVerify empowers you</span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-primary tracking-tight leading-[1.1]">
            Less admin. Tighter compliance.{" "}
            <span className="text-accent">Happier clients.</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-muted-foreground max-w-xl">
            CoVerify replaces scattered tools and manual spreadsheets with one secure,
            connected platform for everything ID verification.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {BENEFITS.map((b, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="lime-tick mt-0.5"><CheckCircle2 className="h-4 w-4" /></span>
                <span className="text-sm md:text-base text-primary/90 font-medium leading-relaxed">{b}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-6">
          <div className="relative rounded-3xl overflow-hidden border border-border shadow-[0_30px_80px_-30px_rgba(14,58,95,0.35)]">
            <img
              src="https://images.unsplash.com/photo-1509017174183-0b7e0278f1ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxtb2JpbGUlMjBwaG9uZSUyMGJpb21ldHJpYyUyMHNjYW4lMjBjb25jZXB0fGVufDB8fHx8MTc4MDkyMDMwNXww&ixlib=rb-4.1.0&q=85"
              alt="Mobile verification concept"
              className="h-full w-full object-cover aspect-[4/5]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-primary/20 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 rounded-2xl bg-white/95 backdrop-blur p-5">
              <div className="flex items-start gap-3">
                <div className="lime-tick"><CheckCircle2 className="h-4 w-4" /></div>
                <div>
                  <div className="font-display font-bold text-primary">Verification complete</div>
                  <div className="text-xs text-muted-foreground mt-1">Personal code generated · Linked to client record</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
